import {getActiveCompetitions, getAwsTokens, submitImage, submit} from '../util/api_calls/PhotowallApiCalls';
import {decodeOtherLanguage} from "../util/helpers/Helpers";

const getAllRounds = (hash, dispatch) => {

    getActiveCompetitions(
        hash,
        payload => {
            if (payload.hasOwnProperty('legacyCharEncoding') && payload.legacyCharEncoding == 0) {
                payload.detail = decodeOtherLanguage(payload.detail);
                payload.description = decodeOtherLanguage(payload.description);
                payload.lastPageCopy = decodeOtherLanguage(payload.lastPageCopy);
                payload.thanksCopy = decodeOtherLanguage(payload.thanksCopy);
                payload.drawCopy = decodeOtherLanguage(payload.drawCopy);
                }

            dispatch(getAllRoundsFinish(payload, dispatch))
        },
        error => {
            dispatch(postError(error))
        }
    );

    return {
        type: 'GET_ALL_ROUNDS_START',
        payload: {}
    }
}

const submitImages = (data, dispatch, successCallback, errorCallback) => {
    submitImage(
        data,
        payload => {
            console.log('test');
            dispatch(submitImageFinish(payload, dispatch))
            successCallback(false);
        },
        error => {
            console.log('----1-----', error);
            dispatch(postError(error))
            errorCallback(false);
        }
    );

    return {
        type: 'SUBMIT_VOTE_START',
        payload: data
    }
}

const submitImageFinish = (payload) => {

    return {
        type: 'SUBMIT_VOTE_FINISH',
        payload: {
            ...payload
        }
    }
}

const getAwsToken = (dispatch) => {

    getAwsTokens(
        payload => {
            dispatch(getAwsTokensFinish(payload, dispatch))
        },
        error => {
            dispatch(postError(error))
        }
    );

    return {
        type: 'GET_AWS_TOKEN_START',
        payload: {}
    }
}

const getAwsTokensFinish = (payload, dispatch) => {

    return {
        type: 'GET_AWS_TOKEN_FINISH',
        payload: {
            ...payload
        }
    }
}

const selectRound = (newRound, dispatch) => {

    return {
        type: 'SELET_NEW_ROUND',
        payload: newRound
    }
}

const submitVote = (payload, token, dispatch) => {
    submit(
        payload, token,
        payload => {
            dispatch(submitVoteFinish(payload))
        },
        error => {
            dispatch(postError(error))
        }
    );

    return {
        type: 'SUBMIT_VOTE_START',
        payload: payload
    }
}

const submitVoteFinish = (payload) => {

    return {
        type: 'SUBMIT_VOTE_FINISH',
        payload: payload
    }
}

const getAllRoundsFinish = (payload, dispatch) => {

    console.log("Looking for leaderboard after Round...");

    return {
        type: 'GET_ALL_ROUNDS_FINISH',
        payload: {
            ...payload
        }
    }
}

const postError = error => {

    console.error("error", error);
    let payload = {}
    if (error.constructor.name === 'Error') {
        // In case 500 is received I don't want to show server's raw error.
        payload = {
            errorMessages: ['There was an error, please contact support.']
        };
    } else {
        payload = {...error};
    }
    return {
        type: "POST_ERROR",
        payload: payload
    }
}


export {getAllRounds, submitImages, getAwsToken, selectRound, submitVote}



// WEBPACK FOOTER //
// ./src/actions/PhotowallActions.js